import React, { Component } from "react";

import Login from "./Login";
import SupportLoginFlow from "./SupportLoginFlow";

class LoginController extends Component {
    state = {
      currentPage: "",
    }

    updateCurrentPage = () => {
      const pathname = this.props.location?.pathname || window.location.pathname;
      if (pathname === "/login/support") {
        this.setState({
          currentPage: "support",
        });
      } else {
        this.setState({
          currentPage: "login",
        });
      }
    }

    componentDidMount() {
      this.updateCurrentPage();
    }

    componentDidUpdate(prevProps) {
      const currentPathname = this.props.location?.pathname || window.location.pathname;
      const prevPathname = prevProps.location?.pathname || window.location.pathname;

      if (currentPathname !== prevPathname) {
        this.updateCurrentPage();
      }
    }

    render() {
      const { currentPage } = this.state;
      const { history } = this.props;

      if (currentPage === "support") {
        return <SupportLoginFlow history={history} />;
      } if (currentPage === "login") {
        return <Login history={history} />;
      }
      return null;
    }
}

export default LoginController;
